import { useRef } from 'react';
import { useTable } from 'src/components';

export const usePagination = () => {
  const logsPagesRef = useRef<Record<number, string>>({});
  const logsRowsPerPageRef = useRef<number>(25);

  const alarmsPagesRef = useRef<Record<number, string>>({});
  const alarmsRowsPerPageRef = useRef<number>(25);

  const logsTable = useTable();
  const alarmsTable = useTable();

  const {
    page: logsPage,
    rowsPerPage: logsRowsPerPage,
    onChangeRowsPerPage: onChangeLogsRowsPerPage,
    setPage: setLogsPage,
  } = logsTable;

  const {
    page: alarmsPage,
    rowsPerPage: alarmsRowsPerPage,
    onChangeRowsPerPage: onChangeAlarmsRowsPerPage,
    setPage: setAlarmsPage,
  } = alarmsTable;

  return {
    alarmsPagesRef,
    alarmsRowsPerPageRef,
    logsPagesRef,
    logsRowsPerPageRef,
    logsPage,
    logsRowsPerPage,
    onChangeLogsRowsPerPage,
    setLogsPage,
    alarmsPage,
    alarmsRowsPerPage,
    onChangeAlarmsRowsPerPage,
    setAlarmsPage,
  };
};
